/* eslint-disable require-jsdoc */
import React, { Component } from 'react';
import SubHeader from '../../components/website/subHeader';
import { withSnackbar } from "notistack";
import axios from "axios";
import ReactPixel from 'react-facebook-pixel';
import CareerForm from '../../components/website/CareerForm';
import { Loader } from '../../components/website/Loader';

class CMSPages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageTitle: null,
            cmsId: null,
            loading: true,
            pageData: null,
        };
    }

    async componentDidMount() {

        const pageTitle = this.props.match.params.pageTitle;
        const cmsId = this.props.match.params.cmsId;
        this.setState({
            pageTitle: pageTitle,
            cmsId: cmsId,
        })
        this.getAllCMS(cmsId);
    }


    async getAllCMS(cmsId) {
        this.setState({ loading: true })
        axios.get(process.env.react_app_base_url + '/api/v1/cms/pages/' + cmsId + "?status=0")
            .then(res => {
                console.log("CMS Pages res", res)
                this.setState({ pageData: res.data.data, loading: false })
            })
            .catch(error => {
                console.log("error.response.status", error)
            });
    }

    render() {
        return (
            <React.Fragment>
                {this.state.loading === true ?
                    <Loader></Loader> :
                    <React.Fragment>
                        <SubHeader title={this.state.pageData.title}></SubHeader>
                        <div className="courseDetails careerDetails">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-md-8 col-sm-12 text-left CMSPages">
                                        <div className='short_description'>
                                            <h1>{this.state.pageData.title}</h1>
                                            {this.state.pageData?.short_description}
                                        </div>

                                        {this.state.pageData.image === null && this.state.pageData.image === "null" ?
                                            '' :
                                            <div className="imagePlaceholder">
                                                <img alt="" src={process.env.react_app_base_url + "/" + this.state.pageData.image} />
                                            </div>
                                        }
                                        <div dangerouslySetInnerHTML={{ __html: this.state.pageData.description }}></div>
                                    </div>
                                    <div className="col-md-4 col-sm-12 text-left CMSPages">
                                        <div className="innerForm">
                                            <p className='paraDuration'>Session Duration : 1 hour</p>
                                            <p className='fees'>Fees: INR 2500.00</p>
                                            <p style={{ marginTop: '-20px', fontSize: '14px' }}>Inclusive of applicable taxes</p>


                                            <h4>Register for {this.state.pageData.title}</h4>
                                            <CareerForm></CareerForm>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

export default withSnackbar(CMSPages);
